/**
 * RESPONSIBILITY: draw the House of Honor appeal page.
 *
 * The photo is shown whole, not cropped into a hero: a rendering of a building is a
 * document somebody wants to actually look at, and a hero band's job is to crop a wide
 * image down to fit behind a title — exactly the opposite of what this picture is for.
 */
import { Html } from '@framework/react';
import type { HouseOfHonorSection } from '@app/sections';
import { Picture } from '../commons/Picture';
import { PageHead } from '../commons/PageHead';
import { Crumbs } from '../commons/Crumbs';
import { Page, hrefFor } from '../commons/pages';

export function HouseOfHonor({ c }: { c: HouseOfHonorSection }) {
  const highlights = c.highlights ?? [];

  return (
    <>
      <Crumbs trail={[{ label: c.heading }]} />
      <PageHead eyebrow={c.eyebrow} heading={c.heading} intro={c.intro} />

      <section className="band">
        <div className="wrap">
          <Picture value={c.image} alt="" className="hoh-photo" />
        </div>
        <div className="wrap-narrow">
          {c.bodyHtml && <Html className="md-body lede hoh-body">{c.bodyHtml}</Html>}
        </div>
      </section>

      {highlights.length > 0 && (
        <section className="band band-tint">
          <div className="wrap">
            <div className="grid grid-3">
              {highlights.map((h, i) => (
                <div className="hoh-highlight" key={i}>
                  <h3>{h.title}</h3>
                  {h.blurb && <p>{h.blurb}</p>}
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      <section className="band band-deep band-centre">
        <div className="wrap">
          <div className="btns btns-centre">
            {c.ctaLabel && <a className="btn btn-light" href={c.ctaHref || hrefFor(Page.Give)}>{c.ctaLabel}</a>}
            {c.askLabel && (
              <a className="btn btn-ghost-light" href={c.askHref || hrefFor(Page.Contact)}>{c.askLabel}</a>
            )}
          </div>
        </div>
      </section>
    </>
  );
}
